<div class="agpr-mentionList-container">
    <ul
        [id]="'mentionList'"
        agprListKeyboardNavigation
        [list]="_mentions"
        class="agpr-mentionList"
    >
        <li
            *ngFor="let mention of _mentions; trackBy: mentionTrackBy; let i = index; let f = first; let l = last;"
            class="agpr-mentionList-mention agpr-contextMenu-parent"
            [ngClass]="{
                'agpr-mentionList-firstDuplicate': _groupDuplicates && !l && mention.duplicateGroupId && _mentions[i + 1].duplicateGroupId === mention.duplicateGroupId,
                'agpr-mention--focused': (
                    focusedMention
                    && focusedMention.id === mention.id
                    && focusedMention.mentionId === mention.mentionId
                ),
                'agpr-mentionList-duplicateContainer': (
                    _groupDuplicates
                    && !f
                    && mention.duplicateGroupId
                    && _mentions[i - 1].duplicateGroupId === mention.duplicateGroupId
                ),
                'agpr-mentionList-duplicate--last': (
                    _groupDuplicates
                    && (!f && mention.duplicateGroupId && _mentions[i - 1].duplicateGroupId === mention.duplicateGroupId)
                    && (!l && mention.duplicateGroupId && _mentions[i + 1].duplicateGroupId !== mention.duplicateGroupId)
                ),
                'agpr-mention--saved': !!mention.mentionId && highlightSavedMentions
            }"
            tabindex="0"
            (keydown)="onCardKeydown($event, mention)"
            (agprClickUnless)="clickMentionCard(mention)"
            [agprClickUnlessSelectors]="['a', 'button', 'input', 'agpr-checkbox']"
        >
            @if (topLabelMention
                && topLabelMention.id === mention.id
                && topLabelMention.mentionId === mention.mentionId
                && topLabel) {
                <div class="agpr-mentionList-topLabel">
                    {{ topLabel | localize }}
                </div>
            }
            <div class="agpr-mentionList-content">
                @if (
                    _groupDuplicates &&
                    !f &&
                    mention.duplicateGroupId &&
                    _mentions[i - 1].duplicateGroupId === mention.duplicateGroupId
                ) {
                    <div
                        class="agpr-mentionList-greybar"
                        [ngClass]="{
                            'agpr-mentionList-greybar-first': _mentions[i - 2]?.duplicateGroupId !== mention.duplicateGroupId
                        }"
                    ></div>
                }

                @if (showMentionIndex) {
                    <div class="agpr-mentionList-index">
                        {{ (i + 1) + mentionIndexOffset }}
                    </div>
                }

                @if (!readonly) {
                    <span class="agpr-mentionList-mentionCheckbox">
                        <agpr-checkbox
                            [id]="id + '_mentionCheckbox_' + i"
                            [value]="mention"
                            [hiddenLabel]="mention.headline ? mention.headline : null"
                            [disabled]="checkboxDisabled"
                            [canBeDisabledWhenChecked]="checkboxCanBeDisabledWhenChecked"
                            [(ngModel)]="selectedMentions"
                            (onChange)="checkedStateChange()"
                        ></agpr-checkbox>
                        @if (
                            focusedMention &&
                            focusedMention.id === mention.id &&
                            focusedMention.mentionId === mention.mentionId
                        ) {
                            <div class="agpr-mentionList-mentionSelectionBar"></div>
                        }
                    </span>
                }

                <div class="agpr-mentionList-mentionContainer">
                    <agpr-mention-card
                        #mentionCard
                        [id]="id + '_mention_' + i"
                        [mention]="mention"
                        [highlightKeywords]="highlightKeywords"
                        [badges]="badges"
                        [showImages]="showAllImages"
                        [compact]="compact"
                        [reGetCardHeight]="reGetCardHeight"
                        [mentionContent]="mentionContent"
                        [canExpand]="canExpand"
                        [showPublishedDate]="showPublishedDate"
                        (outletClicked)="outletClicked.emit(mention)"
                        (contactClicked)="contactClicked.emit(mention)"
                        (unlockMentionClicked)="unlockMentionClicked.emit(mention)"
                        (viewAllSyndicatesClicked)="viewAllSyndicatesClicked.emit(mention)"
                        [selectedFolder]="selectedFolder"
                        [metricType]="sortField"
                        [useMentionCardErrorTemplate]="useMentionCardErrorTemplate"
                        [isSyndicateMode]="isSyndicateMode"
                        [mentionSearch]="mentionSearch"
                        [enablePrecisionClip]="!!mentionSearch"
                    >
                        @if (!readonly) {
                            <span class="agpr-mentionList-mentionCheckbox">
                                <agpr-checkbox
                                    [id]="id + '_mentionCheckbox_' + i"
                                    [value]="mention"
                                    [hiddenLabel]="mention.headline ? mention.headline : null"
                                    [(ngModel)]="selectedMentions"
                                    (onChange)="checkedStateChange()"
                                ></agpr-checkbox>
                            </span>
                        }
                    </agpr-mention-card>
                </div>
                <div
                    class="agpr-mentionList-icons agpr-mentionList-icons--right agpr-contextMenu top right"
                    [id]="id"
                >
                    @if (showMentionViewIcon) {
                        <agpr-button
                            [id]="id + '.mention_view.'+ i"
                            class="agpr-mentionList-icon agpr-mentionList-icon--topRight agpr-mentionList-eyeIcon"
                            [style]="buttonTypesEnum.icon"
                            tooltip="Social.intelligence.themeManagement.themeCard.viewTheme.tooltip"
                            tooltipPosition="left"
                            icon="fa-regular fa-duotone fa-eye"
                            (click)="clickMentionCard(mention)"
                        ></agpr-button>
                    }
                    <agpr-button
                        [id]="id + '.manage_mention.'+ i"
                        class="agpr-mentionList-icon agpr-mentionList-icon--topRight agpr-mentionList-gearIcon"
                        [style]="buttonTypesEnum.contextMenu"
                        icon="fa-regular fa-duotone fa-gear"
                        tooltip="Mention.manageMentionOrganization.gearIcon.tooltip"
                        tooltipPosition="left"
                        (click)="openManageMentionOrganizationDialog(mention, $event)"
                    ></agpr-button>
                    @if (openAiPermission &&
                        !mention.isTranslatedPreferred &&
                        !mention.isFinancialTimes &&
                        showTranslate &&
                        mention?.languageModel?.name &&
                        ((mention?.languageModel?.name | localize) !== userLanguage)
                    ) {
                        <agpr-button
                            [id]="id + '.quick-translate' + mention?.id"
                            [icon]="mention.translating ? '' : 'fa-kit-duotone fa-agpr-translate'"
                            [style]="buttonTypesEnum.contextMenu"
                            class="agpr-mentionList-icon agpr-mentionList-icon--topRight"
                            [disabled]="concurrentTranslation >= maxConcurrentTranslation"
                            [ngClass]="{
                                'agpr-mentionList-icon-show': mention.translating
                            }"
                            [tooltip]="(concurrentTranslation >= maxConcurrentTranslation) ?
                                ('Mention.translate.tooManyRequests' | localize : {
                                    max : maxConcurrentTranslation
                                }) :
                                ('Mention.translateTo' | localize: {
                                    language: mention?.showTranslated ? ('Language.' + mention?.language | localize) : userLanguage
                                })
                            "
                            tooltipPosition="top"
                            (click)="mention?.showTranslated ? revertTranslate(mention) : translate(mention)"
                            [loading]="mention.translating"
                        >
                        </agpr-button>
                    }
                </div>
            </div>
            <div class="agpr-mentionList-mentionSelectAll">
                @if (
                    _groupDuplicates &&
                    mention.duplicateGroupId &&
                    (
                        (f || _mentions[i - 1].duplicateGroupId !== mention.duplicateGroupId)
                        && !l && _mentions[i + 1].duplicateGroupId === mention.duplicateGroupId
                    )
                ) {
                    <agpr-checkbox
                        [id]="id + '_mentionCheckbox_' + i"
                        [value]="mention.duplicateGroupId"
                        label="Mention.workbench.actions.selectSimilar"
                        [hiddenLabel]="mention.headline ? mention.headline : null"
                        [disabled]="false"
                        [binary]="true"
                        [canBeDisabledWhenChecked]="checkboxCanBeDisabledWhenChecked"
                        [ngModel]="mentionFlags[mention.duplicateGroupId]"
                        [partialSelected]="partialSelectionFlags[mention.duplicateGroupId]"
                        (onChange)="onDuplicateGroupChecked($event, mention.duplicateGroupId)"
                    ></agpr-checkbox>
                }
            </div>
        </li>
    </ul>
</div>
